// @ts-nocheck

import { createSelector } from 'reselect';

import { selectValidMissions } from '../../modules/missions/selectors/banner';
import { getHistoryFromProps } from '../../selectors/_propsGetters_';
import { selectEntitiesHomeState } from '../../selectors/entities/home/entitiesHomePrimary.selector';
import { selectEntitiesTeasers } from '../../selectors/entities/teasers/entitiesTeasersPrimary.selector';
import { selectHomeMatchesEntities } from '../../selectors/route.selector';
import { selectRuntimeLicence } from '../../selectors/runtime/runtimePrimary.selector';
import {
  selectUserDidReceivedUserData,
  selectUserMissionsModerator,
  selectUserPromotionStatus,
} from '../../selectors/user/userPrimary.selector';
import { Licences } from '../../types/common';
import { PromotionStatuses } from '../../types/promotions';
import { getPreviousMatchId } from '../../utils/history';
import { getImagePath } from '../../utils/image';
import { createShallowEqualSelector } from '../../utils/reselect';

const emptyArray: [] = [];

const selectMatchesData = createSelector([selectEntitiesHomeState, selectHomeMatchesEntities], (entities, matches) => {
  return {
    isLoading: entities === undefined || (entities && entities.matches === undefined),
    isNull: entities === null || (entities && entities.matches === null) || false,
    matches,
  };
});

const getPromotions = createShallowEqualSelector(selectEntitiesTeasers, (teasers) => {
  return teasers.filter((t) => !t.matchId);
});

const selectRouteHomeSelector = createShallowEqualSelector(
  [
    selectMatchesData,
    getPromotions,
    selectValidMissions,
    selectRuntimeLicence,
    selectUserMissionsModerator,
    selectUserPromotionStatus,
    selectUserDidReceivedUserData,
    getHistoryFromProps,
  ],
  (
    { matches, isLoading, isNull },
    promotions,
    validMissions,
    licence,
    missionsModerator,
    promotionStatus,
    didReceivedUserData,
    history,
  ) => {
    if (isLoading || isNull) {
      return {
        list: emptyArray,
        isEmpty: matches.length === 0,
        isLoading,
        isNull,
      };
    }

    const list = [...matches];

    // On injecte les promotions a leur position dans la liste
    // On commence par la fin pour insérer la promo au bon endroit
    for (let i = promotions.length - 1; i >= 0; --i) {
      const promo = promotions[i];
      const {
        position,
        url: promotionUrl,
        wamUrl: promotionWamUrl,
        missionId: promotionMissionId,
        operationId: promotionOperationId,
      } = promo;
      const referencedOpId = promotionMissionId ?? promotionOperationId;
      const computedMissionId = validMissions.find(({ missionId }) => referencedOpId === missionId)
        ? referencedOpId
        : undefined;

      const allowConnectedEs = licence !== Licences.ES || didReceivedUserData;

      if (
        allowConnectedEs &&
        promotionStatus === PromotionStatuses.DEFAULT &&
        !missionsModerator &&
        (computedMissionId ||
          (!referencedOpId && promo.img && promotionUrl && !list.find((el) => el.promotionUrl === promotionUrl)))
      ) {
        list.splice((position ?? 1) - 1, 0, {
          promotionImage: !referencedOpId ? getImagePath(promo.img) : undefined,
          promotionUrl: !referencedOpId ? promotionUrl : undefined,
          promotionWamUrl: !referencedOpId ? promotionWamUrl : undefined,
          promotionMissionId: computedMissionId,
        });
      }
    }

    return {
      list,
      isEmpty: list.length === 0,
      isLoading,
      isNull,
      anchorMatchId: getPreviousMatchId(history),
      licence,
      promotionStatus,
      didReceivedUserData,
    };
  },
);

export default selectRouteHomeSelector;
